module.exports = __webpack_public_path__ + "static/logo-9b8a867adfa1170e2355a8300135fad7.png";